<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <ng-content select=".modal-title"></ng-content>
    <!-- <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <ng-content select=".modal-body"></ng-content>
  <ng-content select=".modal-footer"></ng-content>
</ng-template>